<app-header
  [showBackButton]="true"
  [headerData]="headerDataValues"
  class="full"
></app-header>
<app-offline-mode></app-offline-mode>
<ion-content *ngIf="!expeditorDocGenerating">
  <div class="content-wrapper">
    <div class="spinner" *ngIf="loading">
      <ion-spinner name="lines"></ion-spinner>
    </div>
    <ion-button
      (click)="navBack()"
      class="square light large"
      *ngIf="!endDayConfirmed"
    >
      Исправить день
    </ion-button>

    <div class="end-day-result">
      <div class="weight-block">
        <div class="date">{{ dayData.shipmentDate.split(' ')[0] }}</div>
        <span class="note">Тонн отгружено за день:</span>
        <div class="weight-result">
          <span class="value">{{ totalWeight / 1000 }}</span>
        </div>
      </div>

      <div *ngIf="expeditorNoteDocumentId">
        <app-download-file-button
          [documentId]="expeditorNoteDocumentId"
          [fileName]="'Расписка экспедитора-' + request.contractName + '.pdf'"
          buttonText="Расписка экспедитора"
        ></app-download-file-button>
      </div>

      <div *ngIf="!expeditorNoteDocumentId" class="description">
        По завершению дня экспедиторская расписка будет подписана ПЭП
      </div>
    </div>

    <div *ngIf="endDayConfirmed" class="close-btn-wrapper">
      <ion-button (click)="navBack()" class="square light large">
        Закрыть
      </ion-button>
    </div>
  </div>
</ion-content>

<ion-content *ngIf="expeditorDocGenerating">
  <div class="loading-spiner-wrapper">
    <div class="spiner-wrapper">
      <img src="assets/icon/big-spiner.svg" alt="" />
      <span> Подождите... Формирую расписку Экспедитора </span>
    </div>
  </div>
</ion-content>

<ion-footer *ngIf="!endDayConfirmed">
  <app-swipe-button
    [title]="'Завершить и подписать ПЭП'"
    (swipedEvent)="confirmDay($event)"
    [isSwiped]="endDayConfirmed"
    (clickEvent)="confirmDay(false)"
  >
  </app-swipe-button>
</ion-footer>

